import React, {forwardRef} from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Typography from './Typography.jsx';
import useUniqueId from '../hooks/useUniqueId.js';
import styles from '../styles/styles';
import {DateTimePicker as MaterialDateTimePicker} from '@material-ui/pickers';
const {makeStyles} = styles;


const DateTimePicker = (props, ref) => {
  const classes = useStyles();
  const uniqueId = useUniqueId();
  const {label, name, format, disabled, valueFormat, value, error, ...rest} = props;
  const stringValue = React.useMemo(() => moment(value, valueFormat), [value, valueFormat]);
  const handleChange = (dateMoment) => {
    if (!format) props.onChange(dateMoment.toDate());
    else props.onChange(dateMoment.format(format));
  };
  return (
    <div className={classes.dateWrapper}>
      <MaterialDateTimePicker
        KeyboardButtonProps={{'aria-label': 'change date'}}
        className={ classNames(classes.date, !!error && classes.errorInput) }
        autoOk
        inputVariant={ 'outlined' }
        ampm
        {...rest}
        disabled={disabled}
        id={ uniqueId }
        format={ format || 'MM/DD/yyyy h:mm A' }
        onChange={ handleChange }
        name={ name }
        label={ label }
        value={ stringValue }
        ref={ref}/>
      {
        !!error && (
          <Typography variant={'caption'} className={classes.errorText}>
            {error}
          </Typography>
        )
      }
    </div>
  );
};

DateTimePicker.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  error: PropTypes.node,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  format: PropTypes.string,
  valueFormat: PropTypes.string,
};


const useStyles = makeStyles((theme) => ({
  dateWrapper: {
    height: '100%'
  },
  selectCard: {
    flex: 1,
    width: '100%',
    height: 56,
    backgroundColor: 'white',
    borderRadius: 4,
    boxShadow: `rgba(0,0,0,.07) 0px 0px 12px`,
  },
  dateContainer: {
    // paddingTop: theme.spacing(),
    position: 'relative',
    height: 64 - theme.spacing(2),
  },
  date: {
    width: '100%',
  },
  errorInput: {
    '& label': {
      color: 'red',
    },
    '& div.MuiInputBase-root fieldset': {
      borderColor: 'red',
    },
  },
  errorText: {
    color: 'red',
    paddingLeft: theme.spacing(2),
  },
}));


export default forwardRef(DateTimePicker);
